<template>
    <div>
        <Header></Header>
        <div class="main-inner">
            <div class="card card--bordered w-50 mx-auto pb-0">
                <header class="card__header align-items-center justify-content-between">
                    <h4 class="heading4">Trackers</h4>

                    <div v-if="false" class="d-flex">
                        <h6 class="heading6">Notifications:</h6>
                        <div class="input-radio ml-3">
                            <input type="radio" value="1" id="n1" name="n">
                            <label for="n1">On</label>
                        </div>
                        <div class="input-radio ml-3">
                            <input type="radio" value="1" id="n2" name="n">
                            <label for="n2">Off</label>
                        </div>
                    </div>
                </header>

                <template>
                    <div class="accordion accordion--in-card" role="tablist">
                        <div class="accordion__header mb-0">
                            <div v-b-toggle.accordion-tracker variant="info" class="accordion__title">Details</div>
                        </div>

                        <b-collapse id="accordion-tracker" visible accordion="accordion-tracker" role="tabpanel" class="accordion__content">
                            <div class="input-radio mb-3">
                                <input type="radio" v-model="settings.tracker.is_common" value="1" id="tracker-common-1" name="tracker-common">
                                <label for="tracker-common-1">Use the same settings for all trackers</label>
                            </div>
                            <div class="input-radio">
                                <input type="radio" v-model="settings.tracker.is_common" value="0" id="tracker-common-0" name="tracker-common">
                                <label for="tracker-common-0">Use individual tracker settings</label>
                            </div>

                            <template v-if="settings.tracker.is_common == 1">
                                <b-collapse id="accordion-tracker-0" visible accordion="my-accordion-tracker" role="tabpanel">
                                    <table class="table-simple w-75">
                                        <thead>
                                        <tr>
                                            <th>Event</th>
                                            <th>Real Time</th>
                                            <th>Daily</th>
                                            <th>Weekly</th>
                                            <th>Never</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr>
                                            <td>Startups added/removed</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-link']" value="now" :id="'tracker-startup-link-now'" :name="'tracker-startup-link'">
                                                    <label :for="'tracker-startup-link-now'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-link']" value="day" :id="'tracker-startup-link-day'" :name="'tracker-startup-link'">
                                                    <label :for="'tracker-startup-link-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-link']" value="week" :id="'tracker-startup-link-week'" :name="'tracker-startup-link'">
                                                    <label :for="'tracker-startup-link-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-link']" value="never" :id="'tracker-startup-link-never'" :name="'tracker-startup-link'">
                                                    <label :for="'tracker-startup-link-never'"></label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Team added/removed</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['team-member']" value="now" :id="'tracker-team-member-now'" :name="'tracker-team-member'">
                                                    <label :for="'tracker-team-member-now'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['team-member']" value="day" :id="'tracker-team-member-day'" :name="'tracker-team-member'">
                                                    <label :for="'tracker-team-member-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['team-member']" value="week" :id="'tracker-team-member-week'" :name="'tracker-team-member'">
                                                    <label :for="'tracker-team-member-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['team-member']" value="never" :id="'tracker-team-member-never'" :name="'tracker-team-member'">
                                                    <label :for="'tracker-team-member-never'"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Startup reviewed</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-reviewed']" value="now" :id="'tracker-startup-reviewed-now'" :name="'tracker-startup-reviewed'">
                                                    <label :for="'tracker-startup-reviewed-now'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-reviewed']" value="day" :id="'tracker-startup-reviewed-day'" :name="'tracker-startup-reviewed'">
                                                    <label :for="'tracker-startup-reviewed-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-reviewed']" value="week" :id="'tracker-startup-reviewed-week'" :name="'tracker-startup-reviewed'">
                                                    <label :for="'tracker-startup-reviewed-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-reviewed']" value="never" :id="'tracker-startup-reviewed-never'" :name="'tracker-startup-reviewed'">
                                                    <label :for="'tracker-startup-reviewed-never'"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>News</td>
                                            <td>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['news']" value="day" :id="'tracker-news-day'" :name="'tracker-news'">
                                                    <label :for="'tracker-news-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['news']" value="week" :id="'tracker-news-week'" :name="'tracker-news'">
                                                    <label :for="'tracker-news-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['news']" value="never" :id="'tracker-news-never'" :name="'tracker-news'">
                                                    <label :for="'tracker-news-never'"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>New funding</td>
                                            <td>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['new-funding']" value="day" :id="'tracker-new-funding-day'" :name="'tracker-new-funding'">
                                                    <label :for="'tracker-new-funding-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['new-funding']" value="week" :id="'tracker-new-funding-week'" :name="'tracker-new-funding'">
                                                    <label :for="'tracker-new-funding-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['new-funding']" value="never" :id="'tracker-new-funding-never'" :name="'tracker-new-funding'">
                                                    <label :for="'tracker-new-funding-never'"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Notes / Interactions / Custom Fields updated</td>
                                            <td>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-interaction']" value="day" :id="'tracker-startup-interaction-day'" :name="'tracker-startup-interaction'">
                                                    <label :for="'tracker-startup-interaction-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-interaction']" value="week" :id="'tracker-startup-interaction-week'" :name="'tracker-startup-interaction'">
                                                    <label :for="'tracker-startup-interaction-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings.tracker.common[0].notifications['startup-interaction']" value="never" :id="'tracker-startup-interaction-never'" :name="'tracker-startup-interaction'">
                                                    <label :for="'tracker-startup-interaction-never'"></label>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </b-collapse>
                            </template>

                            <template v-if="settings.tracker.is_common == 0">
                                <div class="accordion mb-0" role="tablist1">

                                    <div v-for="(tracker, index) in settings.tracker.specific" :key="index">

                                        <header class="accordion__header">
                                            <div v-b-toggle="'accordion-tracker-' + tracker.id" variant="info" class="accordion__title accordion__title--small mt-4">
                                                {{ tracker.name }}</div>
                                        </header>

                                        <b-collapse :id="'accordion-tracker-' + tracker.id" visible accordion="my-accordion-tracker" role="tabpanel">
                                            <table class="table-simple w-75">
                                                <thead>
                                                    <tr>
                                                        <th>Event</th>
                                                        <th>Real Time</th>
                                                        <th>Daily</th>
                                                        <th>Weekly</th>
                                                        <th>Never</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>Startups added/removed</td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-link']" value="now" :id="'tracker-' + tracker.id + '-startup-link-now'" :name="'tracker-' + tracker.id + '-startup-link'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-link-now'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-link']" value="day" :id="'tracker-' + tracker.id + '-startup-link-day'" :name="'tracker-' + tracker.id + '-startup-link'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-link-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-link']" value="week" :id="'tracker-' + tracker.id + '-startup-link-week'" :name="'tracker-' + tracker.id + '-startup-link'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-link-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-link']" value="never" :id="'tracker-' + tracker.id + '-startup-link-never'" :name="'tracker-' + tracker.id + '-startup-link'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-link-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Team added/removed</td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['team-member']" value="now" :id="'tracker-' + tracker.id + '-team-member-now'" :name="'tracker-' + tracker.id + '-team-member'">
                                                                <label :for="'tracker-' + tracker.id + '-team-member-now'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['team-member']" value="day" :id="'tracker-' + tracker.id + '-team-member-day'" :name="'tracker-' + tracker.id + '-team-member'">
                                                                <label :for="'tracker-' + tracker.id + '-team-member-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['team-member']" value="week" :id="'tracker-' + tracker.id + '-team-member-week'" :name="'tracker-' + tracker.id + '-team-member'">
                                                                <label :for="'tracker-' + tracker.id + '-team-member-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['team-member']" value="never" :id="'tracker-' + tracker.id + '-team-member-never'" :name="'tracker-' + tracker.id + '-team-member'">
                                                                <label :for="'tracker-' + tracker.id + '-team-member-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>Startup reviewed</td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-reviewed']" value="now" :id="'tracker-' + tracker.id + '-startup-reviewed-now'" :name="'tracker-' + tracker.id + '-startup-reviewed'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-reviewed-now'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-reviewed']" value="day" :id="'tracker-' + tracker.id + '-startup-reviewed-day'" :name="'tracker-' + tracker.id + '-startup-reviewed'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-reviewed-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-reviewed']" value="week" :id="'tracker-' + tracker.id + '-startup-reviewed-week'" :name="'tracker-' + tracker.id + '-startup-reviewed'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-reviewed-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-reviewed']" value="never" :id="'tracker-' + tracker.id + '-startup-reviewed-never'" :name="'tracker-' + tracker.id + '-startup-reviewed'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-reviewed-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>News</td>
                                                        <td>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['news']" value="day" :id="'tracker-' + tracker.id + '-news-day'" :name="'tracker-' + tracker.id + '-news'">
                                                                <label :for="'tracker-' + tracker.id + '-news-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['news']" value="week" :id="'tracker-' + tracker.id + '-news-week'" :name="'tracker-' + tracker.id + '-news'">
                                                                <label :for="'tracker-' + tracker.id + '-news-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['news']" value="never" :id="'tracker-' + tracker.id + '-news-never'" :name="'tracker-' + tracker.id + '-news'">
                                                                <label :for="'tracker-' + tracker.id + '-news-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>New funding</td>
                                                        <td>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['new-funding']" value="day" :id="'tracker-' + tracker.id + '-new-funding-day'" :name="'tracker-' + tracker.id + '-new-funding'">
                                                                <label :for="'tracker-' + tracker.id + '-new-funding-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['new-funding']" value="week" :id="'tracker-' + tracker.id + '-new-funding-week'" :name="'tracker-' + tracker.id + '-new-funding'">
                                                                <label :for="'tracker-' + tracker.id + '-new-funding-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['new-funding']" value="never" :id="'tracker-' + tracker.id + '-new-funding-never'" :name="'tracker-' + tracker.id + '-new-funding'">
                                                                <label :for="'tracker-' + tracker.id + '-new-funding-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>Notes / Interactions / Custom Fields updated</td>
                                                        <td>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-interaction']" value="day" :id="'tracker-' + tracker.id + '-startup-interaction-day'" :name="'tracker-' + tracker.id + '-startup-interaction'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-interaction-day'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-interaction']" value="week" :id="'tracker-' + tracker.id + '-startup-interaction-week'" :name="'tracker-' + tracker.id + '-startup-interaction'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-interaction-week'"></label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="input-radio">
                                                                <input type="radio" v-model="settings.tracker.specific[index].notifications['startup-interaction']" value="never" :id="'tracker-' + tracker.id + '-startup-interaction-never'" :name="'tracker-' + tracker.id + '-startup-interaction'">
                                                                <label :for="'tracker-' + tracker.id + '-startup-interaction-never'"></label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-collapse>
                                    </div>
                                </div>
                            </template>
                        </b-collapse>
                    </div>
                </template>
            </div>
            
            <div class="card card--bordered w-50 mx-auto pb-0">
                <header class="card__header align-items-center justify-content-between">
                    <h4 class="heading4">Saved Searches</h4>
                    
                    <div v-if="false" class="d-flex">
                        <h6 class="heading6">Notifications:</h6>
                        <div class="input-radio ml-3">
                            <input type="radio" value="1" id="n10" name="n00">
                            <label for="n10">On</label>
                        </div>
                        <div class="input-radio ml-3">
                            <input type="radio" value="1" id="n20" name="n00">
                            <label for="n20">Off</label>
                        </div>
                    </div>
                </header>

                <template>
                    <div class="accordion accordion--in-card" role="tablist">
                        <div class="accordion__header mb-0">
                            <div v-b-toggle.accordion-saved-search variant="info" class="accordion__title">Details</div>
                        </div>

                        <b-collapse id="accordion-saved-search" visible accordion="accordion-saved-search" role="tabpanel" class="accordion__content">
                            <div class="input-radio mb-3">
                                <input type="radio" v-model="settings['saved-search'].is_common" value="1" id="saved-search-common-1" name="saved-search-common">
                                <label for="saved-search-common-1">Use the same settings for all searches</label>
                            </div>
                            <div class="input-radio">
                                <input type="radio" v-model="settings['saved-search'].is_common" value="0" id="saved-search-common-0" name="saved-search-common">
                                <label for="saved-search-common-0">Use individual search settings</label>
                            </div>

                            <template v-if="settings['saved-search'].is_common == 1">
                                <b-collapse id="accordion-saved-search-0" visible accordion="my-accordion-saved-search" role="tabpanel">
                                    <table class="table-simple w-75">
                                        <thead>
                                        <tr>
                                            <th>Event</th>
                                            <th>Daily</th>
                                            <th>Weekly</th>
                                            <th>Never</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr>
                                            <td>New startup matches</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-startup-matches']" value="day" :id="'saved-search-new-startup-matches-day'" :name="'saved-search-new-startup-matches'">
                                                    <label :for="'saved-search-new-startup-matches-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-startup-matches']" value="week" :id="'saved-search-new-startup-matches-week'" :name="'saved-search-new-startup-matches'">
                                                    <label :for="'saved-search-new-startup-matches-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-startup-matches']" value="never" :id="'saved-search-new-startup-matches-never'" :name="'saved-search-new-startup-matches'">
                                                    <label :for="'saved-search-new-startup-matches-never'"></label>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>News</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['news']" value="day" :id="'saved-search-news-day'" :name="'saved-search-news'">
                                                    <label :for="'saved-search-news-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['news']" value="week" :id="'saved-search-news-week'" :name="'saved-search-news'">
                                                    <label :for="'saved-search-news-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['news']" value="never" :id="'saved-search-news-never'" :name="'saved-search-news'">
                                                    <label :for="'saved-search-news-never'"></label>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>New funding</td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-funding']" value="day" :id="'saved-search-new-funding-day'" :name="'saved-search-new-funding'">
                                                    <label :for="'saved-search-new-funding-day'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-funding']" value="week" :id="'saved-search-new-funding-week'" :name="'saved-search-new-funding'">
                                                    <label :for="'saved-search-new-funding-week'"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-radio">
                                                    <input type="radio" v-model="settings['saved-search'].common[0].notifications['new-funding']" value="never" :id="'saved-search-new-funding-never'" :name="'saved-search-new-funding'">
                                                    <label :for="'saved-search-new-funding-never'"></label>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </b-collapse>
                            </template>

                            <template v-if="settings['saved-search'].is_common == 0">
                                <div class="accordion mb-0" role="tablist1">

                                    <div v-for="(search, index) in settings['saved-search'].specific" :key="index">

                                        <header class="accordion__header">
                                            <div v-b-toggle="'accordion-saved-search-' + search.id" variant="info" class="accordion__title accordion__title--small mt-4">
                                                {{ search.name }}</div>
                                        </header>

                                        <b-collapse :id="'accordion-saved-search-' + search.id" visible accordion="my-accordion-saved-search" role="tabpanel">
                                            <table class="table-simple w-75">
                                                <thead>
                                                <tr>
                                                    <th>Event</th>
                                                    <th>Daily</th>
                                                    <th>Weekly</th>
                                                    <th>Never</th>
                                                </tr>
                                                </thead>

                                                <tbody>
                                                <tr>
                                                    <td>New startup matches</td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-startup-matches']" value="day" :id="'saved-search-' + search.id + '-new-startup-matches-day'" :name="'saved-search-' + search.id + '-new-startup-matches'">
                                                            <label :for="'saved-search-' + search.id + '-new-startup-matches-day'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-startup-matches']" value="week" :id="'saved-search-' + search.id + '-new-startup-matches-week'" :name="'saved-search-' + search.id + '-new-startup-matches'">
                                                            <label :for="'saved-search-' + search.id + '-new-startup-matches-week'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-startup-matches']" value="never" :id="'saved-search-' + search.id + '-new-startup-matches-never'" :name="'saved-search-' + search.id + '-new-startup-matches'">
                                                            <label :for="'saved-search-' + search.id + '-new-startup-matches-never'"></label>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>News</td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['news']" value="day" :id="'saved-search-' + search.id + '-news-day'" :name="'saved-search-' + search.id + '-news'">
                                                            <label :for="'saved-search-' + search.id + '-news-day'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['news']" value="week" :id="'saved-search-' + search.id + '-news-week'" :name="'saved-search-' + search.id + '-news'">
                                                            <label :for="'saved-search-' + search.id + '-news-week'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['news']" value="never" :id="'saved-search-' + search.id + '-news-never'" :name="'saved-search-' + search.id + '-news'">
                                                            <label :for="'saved-search-' + search.id + '-news-never'"></label>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>New funding</td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-funding']" value="day" :id="'saved-search-' + search.id + '-new-funding-day'" :name="'saved-search-' + search.id + '-new-funding'">
                                                            <label :for="'saved-search-' + search.id + '-new-funding-day'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-funding']" value="week" :id="'saved-search-' + search.id + '-new-funding-week'" :name="'saved-search-' + search.id + '-new-funding'">
                                                            <label :for="'saved-search-' + search.id + '-new-funding-week'"></label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="input-radio">
                                                            <input type="radio" v-model="settings['saved-search'].specific[index].notifications['new-funding']" value="never" :id="'saved-search-' + search.id + '-new-funding-never'" :name="'saved-search-' + search.id + '-new-funding'">
                                                            <label :for="'saved-search-' + search.id + '-new-funding-never'"></label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </b-collapse>
                                    </div>
                                </div>
                            </template>
                        </b-collapse>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/settings/Header"
import user from "@/services/user.service";

export default {
    components: {
        Header
    },

    data() {
        return {
            settings: {
                'tracker': {
                    'is_common': null,
                    'common': [],
                    'specific': [],
                },
                'saved-search': {
                    'is_common': null,
                    'common': [],
                    'specific': [],
                },
            },

            canWatch: false,
            updateSettings: false,
        }
    },

    watch: {
        settings: {
            deep: true,
            handler() {
                if (this.canWatch) {
                    let data = {
                        settings: this.settings
                    }

                    user.updateNotificationSettings(data)
                }
            }
        }
    },

    mounted() {
        user.getNotificationSettings().then(result => {
            this.settings = result.data
            this.$nextTick(() => {
                this.canWatch = true
            })
        })
    },
}
</script>

<style scoped>

</style>